const defaultState = {
  lt_countdown: 0,
  lt_question: "",
  cc_countdown: null,
  question: "",
  caption: "",
  answers: ["", "", "", ""],
  correct_answer: [false, false, false, false],
  cc_vote: null,
  has_answered: false,
  ttl_modal_open: false,
  ttl_truths: ["", ""],
  ttl_lie: "",
  ttl_guesser: {
    clicked: false,
    confirmed: false,
    guessed: null,
  },
  ttl_users_list: {
    lie: [],
    truth_1: [],
    truth_2: [],
  },
  ttl_user_score: null,
  ttl_players_array: [],
};

const sbsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_LT_COUNTDOWN": {
      return {
        ...state,
        lt_countdown: action.data,
      };
    }
    case "SET_LT_QUESTION": {
      return {
        ...state,
        lt_question: action.data,
      };
    }
    case "SET_QUESTION": {
      return {
        ...state,
        question: action.data,
      };
    }
    case "SET_ANSWERS": {
      return {
        ...state,
        answers: action.data,
      };
    }
    case "SET_CORRECT_ANSWER": {
      return {
        ...state,
        correct_answer: action.data,
      };
    }
    case "RESET_LTS_STATE": {
      return {
        ...state,
        question: "",
        answers: ["", "", "", ""],
        correct_answer: [false, false, false, false],
      };
    }
    case "SET_CC_COUNTDOWN": {
      return {
        ...state,
        cc_countdown: action.data,
      };
    }
    case "SET_CAPTION": {
      return {
        ...state,
        caption: action.data,
      };
    }
    case "SET_CC_VOTE": {
      return {
        ...state,
        cc_vote: action.data,
      };
    }
    case "SET_HAS_ANSWERED": {
      return {
        ...state,
        has_answered: action.data,
      };
    }
    case "SET_TTL_MODAL_OPEN": {
      return {
        ...state,
        ttl_modal_open: action.data,
      };
    }
    case "SET_TTL_TRUTHS": {
      return {
        ...state,
        ttl_truths: action.data,
      };
    }
    case "SET_TTL_LIE": {
      return {
        ...state,
        ttl_lie: action.data,
      };
    }
    case "SET_TTL_GUESSER": {
      return {
        ...state,
        ttl_guesser: action.data,
      };
    }
    case "SET_TTL_USERS_LIST": {
      return {
        ...state,
        ttl_users_list: action.data,
      };
    }
    case "SET_TTL_USER_SCORE": {
      return {
        ...state,
        ttl_user_score: action.data,
      };
    }
    case "SET_TTL_PLAYERS_ARRAY": {
      return {
        ...state,
        ttl_players_array: action.data,
      };
    }

    default:
      return state;
  }
};

export default sbsReducer;
